<template>
  <div class="right">
    <div class="title-body">
      <div class="title-body-title">
        分支机构场所地址联系电话
        <div
          style="
            flex: 1;
            height: 4px;
            margin-top: 18px;
            margin-left: 10px;
            background-image: url(./static/img/bar.png);
          "
        ></div>
      </div>
    </div>
    <div class="infomation">
      <!--内容开始-->
      <div class="tableList" imgwidth="100" imgheight="130">
        <div
          class="el-table el-table--fit el-table--border el-table--enable-row-hover el-table--enable-row-transition"
        >
          <div class="hidden-columns">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <div class="el-table__header-wrapper">
            <table
              cellspacing="0"
              cellpadding="0"
              border="0"
              class="el-table__header"
              style="width: 994px"
            >
              <colgroup>
                <col name="el-table_35_column_136" width="80" />
                <col name="el-table_35_column_137" width="306" />
                <col name="el-table_35_column_138" width="304" />
                <col name="el-table_35_column_139" width="304" />
                <col name="gutter" width="0" />
              </colgroup>
              <thead class="has-gutter">
                <tr class="">
                  <th
                    colspan="1"
                    rowspan="1"
                    class="el-table_35_column_136 is-center is-leaf"
                    style="
                      background-color: rgb(241, 241, 241);
                      font-size: 16px;
                      font-weight: bold;
                      color: rgb(51, 51, 51);
                    "
                  >
                    <div class="cell">序号</div>
                  </th>
                  <th
                    colspan="1"
                    rowspan="1"
                    class="el-table_35_column_137 is-center is-leaf"
                    style="
                      background-color: rgb(241, 241, 241);
                      font-size: 16px;
                      font-weight: bold;
                      color: rgb(51, 51, 51);
                    "
                  >
                    <div class="cell">名称</div>
                  </th>
                  <th
                    colspan="1"
                    rowspan="1"
                    class="el-table_35_column_138 is-center is-leaf"
                    style="
                      background-color: rgb(241, 241, 241);
                      font-size: 16px;
                      font-weight: bold;
                      color: rgb(51, 51, 51);
                    "
                  >
                    <div class="cell">地址</div>
                  </th>
                  <th
                    colspan="1"
                    rowspan="1"
                    class="el-table_35_column_139 is-center is-leaf"
                    style="
                      background-color: rgb(241, 241, 241);
                      font-size: 16px;
                      font-weight: bold;
                      color: rgb(51, 51, 51);
                    "
                  >
                    <div class="cell">电话</div>
                  </th>
                  <th class="gutter" style="width: 0px; display: none"></th>
                </tr>
              </thead>
            </table>
          </div>
          <div class="el-table__body-wrapper is-scrolling-none">
            <table
              cellspacing="0"
              cellpadding="0"
              border="0"
              class="el-table__body"
              style="width: 994px"
            >
              <colgroup>
                <col name="el-table_35_column_136" width="80" />
                <col name="el-table_35_column_137" width="306" />
                <col name="el-table_35_column_138" width="304" />
                <col name="el-table_35_column_139" width="304" />
              </colgroup>
              <tbody>
                <tr class="el-table__row">
                  <td
                    rowspan="1"
                    colspan="1"
                    class="el-table_35_column_136 is-center"
                  >
                    <div class="cell">1</div>
                  </td>
                  <td
                    rowspan="1"
                    colspan="1"
                    class="el-table_35_column_137 is-center"
                  >
                    <div class="cell">
                      <div style="display: inline-block">
                        <!---->
                        <!---->
                        中智保险经纪(上海)有限公司
                        <!---->
                        <!---->
                      </div>
                    </div>
                  </td>
                  <td
                    rowspan="1"
                    colspan="1"
                    class="el-table_35_column_138 is-center"
                  >
                  上海市徐汇区沪闵路9299号18楼1806室
                  </td>
                  <td
                    rowspan="1"
                    colspan="1"
                    class="el-table_35_column_139 is-center"
                  >
                    021-34014626
                  </td>
                </tr>
                <tr class="el-table__row">
                  <td
                    rowspan="1"
                    colspan="1"
                    class="el-table_35_column_136 is-center"
                  >
                    <div class="cell">2</div>
                  </td>
                  <td
                    rowspan="1"
                    colspan="1"
                    class="el-table_35_column_137 is-center"
                  >
                    中智保险经纪(上海)有限公司北京分公司
                  </td>
                  <td
                    rowspan="1"
                    colspan="1"
                    class="el-table_35_column_138 is-center"
                  >
                    北京市朝阳区光华路7号汉威大厦28层B1室
                  </td>
                  <td
                    rowspan="1"
                    colspan="1"
                    class="el-table_35_column_139 is-center"
                  >
                    010-65613920
                  </td>
                </tr>
                <tr class="el-table__row">
                  <td
                    rowspan="1"
                    colspan="1"
                    class="el-table_35_column_136 is-center"
                  >
                    <div class="cell">3</div>
                  </td>
                  <td
                    rowspan="1"
                    colspan="1"
                    class="el-table_35_column_137 is-center"
                  >
                    中智保险经纪(上海)有限公司江苏分公司
                  </td>
                  <td
                    rowspan="1"
                    colspan="1"
                    class="el-table_35_column_138 is-center"
                  >
                    苏州高新区狮山街道狮山路22号1幢101室人才广场2503
                  </td>
                  <td
                    rowspan="1"
                    colspan="1"
                    class="el-table_35_column_139 is-center"
                  >
                    0512-68555312
                  </td>
                </tr>

                <!---->
              </tbody>
            </table>
            <!----><!---->
          </div>
          <!----><!----><!----><!---->
          <div
            class="el-table__column-resize-proxy"
            style="display: none"
          ></div>
        </div>
      </div>
      <!--内容结束-->
    </div>
  </div>
</template>

<script>
export default {
  name: "RegisteredTrademark",
  components: {},
  data() {
    return {};
  },
  mounted() {}
};
</script>

<style scoped lang="less">
@import "./../assets/table";
</style>



// WEBPACK FOOTER //
// src/pages/registeredTrademark.vue